import { useQuery } from '@tanstack/react-query';
import type { FetchViewersForPatientResponseT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { fetchCarePatientViewers } from '../api/fetchPatientViewers.js';
import { carePatientsKeys } from './keys.js';

export function carePatientViewersQueryDefinition(userId: string) {
  return {
    queryKey: carePatientsKeys.viewers(userId),
    queryFn: ({ signal }: { signal?: AbortSignal }): Promise<FetchViewersForPatientResponseT> =>
      fetchCarePatientViewers(userId, signal),
    staleTime: 5_000,
    refetchInterval: 10_000,
    refetchIntervalInBackground: false,
  } as const;
}

export function useCarePatientViewersQuery(userId: string) {
  return useQuery({
    ...carePatientViewersQueryDefinition(userId),
    enabled: userId !== '',
  });
}
